// store.js
import React, { createContext, useReducer } from "react";
import Utils from "../services/Utils";
const initialState = {
  user: [],
  users: [],
  isAuth: Utils.checkToken(),
  loader: false,
  operations: [],
  operationsForMerch: [],
  operationsType: [],
  dataSelectedClient: Utils.getCurrentSelectedCustomer(),
  dataCustomer: [],
  dataCustomersAdmin: [],
  listUserRoles: [
    {
      id: 1,
      name: "Digeek",
    },
    {
      id: 2,
      name: "Admin Trade",
    },
    {
      id: 3,
      name: "Team Trade",
    },
    {
      id: 4,
      name: "KAM",
    },
    {
      id: 5,
      name: "DV,DR",
    },
    {
      id: 6,
      name: "VRP",
    },
  ],
  listBrands: [],
  listYears: [],
  listComTools: [],
  listPrestataires: [],
  visuelRapport: [],
  listAmbassadrices: [],
  listTypesPlv: [],
  listCustomerPlv: [],
  listInterlocutorsCustomer: [],
  interlocutorKamCustomer: [],
  customerLogs: [],
  allMonth: [
    { value: 0, label: "Tous" },
    { value: 1, label: "Janvier" },
    { value: 2, label: "Février" },
    { value: 3, label: "Mars" },
    { value: 4, label: "Avril" },
    { value: 5, label: "Mai" },
    { value: 6, label: "Juin" },
    { value: 7, label: "Juillet" },
    { value: 8, label: "Août" },
    { value: 9, label: "Septembre" },
    { value: 10, label: "Octobre" },
    { value: 11, label: "Novembre" },
    { value: 12, label: "Décembre" },
  ],
  currentYear: JSON.parse(localStorage.getItem("currentYear")),
  currentBrands: Utils.getCurrentBrands(),
  plansListTrade: [],
  detailsPlanOperations: [],
  listDetailsPlanPlvs: [],
  plansTradeCustomersList: [],
  plansTradeDetailsCustomersList: [],
  allGroups: [],
  allStatus: [
    { value: "0", label: "Tous les status" },
    { value: "1", label: "Grand compte" },
    { value: "2", label: "Premium" },
  ],

  // <JC
  allBrands: [
    { value: "1", label: "Avène" },
    { value: "2", label: "Oral Care" },
    { value: "3", label: "René Furterer" },
    { value: "4", label: "A-Derma" },
    { value: "5", label: "Ducray" },
    { value: "6", label: "Klorane" },
  ],
  operationsTypeDistinct: [],
  // JC>

  customersListFilter: [],
  totalNumberOfCustomerOperations: 0,
  challengesType: [],
  challenges: [],
  totalNumberOfCustomerChallenges: [],
};
const store = createContext(initialState);
const { Provider } = store;
const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((curState, action) => {
    switch (action.type) {
      case "SET_LOADER": {
        const newState = {
          ...curState,
          loader: action.payload,
        };
        return newState;
      }
      case "SET_DATASELECTEDCLIENT": {
        const newState = {
          ...curState,
          dataSelectedClient: action.payload,
        };
        return newState;
      }
      case "SET_TOTALNUMBEROFCUSTOMEROPERATIONS": {
        const newState = {
          ...curState,
          totalNumberOfCustomerOperations: action.payload,
        };
        return newState;
      }
      case "SET_TOTALNUMBEROFCUSTOMERCHALLENGES": {
        const newState = {
          ...curState,
          totalNumberOfCustomerChallenges: action.payload,
        };
        return newState;
      }
      case "SET_DATACUSTOMERSADMIN": {
        const newState = {
          ...curState,
          dataCustomersAdmin: action.payload,
        };
        return newState;
      }
      case "SET_DATACUSTOMER": {
        const newState = {
          ...curState,
          dataCustomer: action.payload,
        };
        return newState;
      }
      case "SET_LISTAMBASSADRICES": {
        const newState = {
          ...curState,
          listAmbassadrices: action.payload,
        };
        return newState;
      }
      case "SET_INTERLOCUTORKAMCUSTOMER": {
        const newState = {
          ...curState,
          interlocutorKamCustomer: action.payload,
        };
        return newState;
      }
      case "SET_LISTINTERLOCUTORSCUSTOMER": {
        const newState = {
          ...curState,
          listInterlocutorsCustomer: action.payload,
        };
        return newState;
      }
      case "SET_AUTH": {
        const newState = {
          ...curState,
          isAuth: action.payload,
          // Si des valeurs de state sont stockées en amont, il faut les "remplir" à la connection, pour être sûr que le state soit chargé avec les données et non vide.
          listUserRoles: [
            {
              id: 1,
              name: "Digeek",
            },
            {
              id: 2,
              name: "Admin Trade",
            },
            {
              id: 3,
              name: "Team Trade",
            },
            {
              id: 4,
              name: "KAM",
            },
            {
              id: 5,
              name: "DV,DR",
            },
            {
              id: 6,
              name: "VRP",
            },
          ],
          allMonth: [
            { value: 0, label: "Tous" },
            { value: 1, label: "Janvier" },
            { value: 2, label: "Février" },
            { value: 3, label: "Mars" },
            { value: 4, label: "Avril" },
            { value: 5, label: "Mai" },
            { value: 6, label: "Juin" },
            { value: 7, label: "Juillet" },
            { value: 8, label: "Août" },
            { value: 9, label: "Septembre" },
            { value: 10, label: "Octobre" },
            { value: 11, label: "Novembre" },
            { value: 12, label: "Décembre" },
          ],
          allStatus: [
            { value: "0", label: "Tous les status" },
            { value: "1", label: "Grand compte" },
            { value: "2", label: "Premium" },
          ],

          // <JC
          allBrands: [
            { value: "1", label: "Avène" },
            { value: "2", label: "Oral Care" },
            { value: "3", label: "René Furterer" },
            { value: "4", label: "A-Derma" },
            { value: "5", label: "Ducray" },
            { value: "6", label: "Klorane" },
          ],
          operationsTypeDistinct: [],
          // JC>

        };
        return newState;
      }
      case "SET_USER": {
        const newState = {
          ...curState,
          user: action.payload,
        };
        return newState;
      }
      case "SET_USERS": {
        const newState = {
          ...curState,
          users: action.payload,
        };
        return newState;
      }
      case "SET_VISUELRAPPORT": {
        const newState = {
          ...curState,
          visuelRapport: action.payload,
        };
        return newState;
      }
      case "SET_LISTUSERROLES": {
        const newState = {
          ...curState,
          listUserRoles: action.payload,
        };
        return newState;
      }
      case "SET_LISTBRANDS": {
        const newState = {
          ...curState,
          listBrands: action.payload,
        };
        return newState;
      }
      case "SET_LISTYEARS": {
        const newState = {
          ...curState,
          listYears: action.payload,
        };
        return newState;
      }
      case "SET_CURRENTYEAR": {
        const newState = {
          ...curState,
          currentYear: action.payload,
        };
        return newState;
      }
      case "SET_CURRENTBRANDS": {
        const newState = {
          ...curState,
          currentBrands: action.payload,
        };
        return newState;
      }
      case "SET_LISTCOMTOOLS": {
        const newState = {
          ...curState,
          listComTools: action.payload,
        };
        return newState;
      }
      case "SET_LISTTYPESPLV": {
        const newState = {
          ...curState,
          listTypesPlv: action.payload,
        };
        return newState;
      }
      case "SET_LISTCUSTOMERPLV": {
        const newState = {
          ...curState,
          listCustomerPlv: action.payload,
        };
        return newState;
      }
      case "SET_LISTPRESTATAIRES": {
        const newState = {
          ...curState,
          listPrestataires: action.payload,
        };
        return newState;
      }
      case "SET_PLANSTRADELIST": {
        const newState = {
          ...curState,
          plansListTrade: action.payload,
        };
        return newState;
      }
      case "SET_DETAILSPLANOPERATIONS": {
        const newState = {
          ...curState,
          detailsPlanOperations: action.payload,
        };
        return newState;
      }
      case "SET_LISTDETAILSPLANPLVS": {
        const newState = {
          ...curState,
          listDetailsPlanPlvs: action.payload,
        };
        return newState;
      }
      case "SET_PLANSTRADECUSTOMERSLIST": {
        const newState = {
          ...curState,
          plansTradeCustomersList: action.payload,
        };
        return newState;
      }
      case "SET_PLANSTRADEDETAILSCUSTOMERSLIST": {
        const newState = {
          ...curState,
          plansTradeDetailsCustomersList: action.payload,
        };
        return newState;
      }
      case "SET_ALLGROUPS": {
        const newState = {
          ...curState,
          allGroups: action.payload,
        };
        return newState;
      }
      case "SET_CUSTOMERSLISTFILTER": {
        const newState = {
          ...curState,
          customersListFilter: action.payload,
        };
        return newState;
      }
      case "SET_LOGOUT": {
        const newState = {
          user: [],
          users: [],
          isAuth: action.payload,
          loader: false,
          operations: [],
          operationsForMerch: [],
          operationsType: [],
          dataSelectedClient: [],
          dataCustomer: [],
          dataCustomersAdmin: [],
          listUserRoles: [],
          listBrands: [],
          listYears: [],
          listComTools: [],
          listPrestataires: [],
          visuelRapport: [],
          listAmbassadrices: [],
          listTypesPlv: [],
          listCustomerPlv: [],
          listInterlocutorsCustomer: [],
          interlocutorKamCustomer: [],
          customerLogs: [],
          allMonth: [],
          currentYear: [],
          currentBrands: [],
          plansListTrade: [],
          detailsPlanOperations: [],
          listDetailsPlanPlvs: [],
          plansTradeCustomersList: [],
          plansTradeDetailsCustomersList: [],
          allGroups: [],
          allStatus: [],

          // <JC
          allBrands: [],
          operationsTypeDistinct: [],
          // JC>

          customersListFilter: [],
          totalNumberOfCustomerOperations: 0,
          challengesType: [],
          challenges: [],
          totalNumberOfCustomerChallenges: [],
        };
        return newState;
      }
      case "SET_OPERATIONSTYPE": {
        const newState = {
          ...curState,
          operationsType: action.payload,
        };
        return newState;
      }
      // <JC
      case "SET_OPERATIONSTYPEDISTINCT": {
        const newState = {
          ...curState,
          operationsTypeDistinct: action.payload,
        };
        return newState;
      }
      // JC>
      case "SET_OPERATIONS": {
        const newState = {
          ...curState,
          operations: action.payload,
        };
        return newState;
      }
      case "SET_CHALLENGESTYPE": {
        const newState = {
          ...curState,
          challengesType: action.payload,
        };
        return newState;
      }
      case "SET_CHALLENGES": {
        const newState = {
          ...curState,
          challenges: action.payload,
        };
        return newState;
      }
      case "SET_OPERATIONSFORMERCHANDISING": {
        const newState = {
          ...curState,
          operationsForMerch: action.payload,
        };
        return newState;
      }
      case "SET_CUSTOMERLOG": {
        const newState = {
          ...curState,
          customerLogs: action.payload,
        };
        return newState;
      }
      default:
        throw new Error();
    }
  }, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};
export { store, StateProvider };
